

<div class="containers" #containers >
<div class="outside-container mt-4">
  <div class="box-container ">

      <div class="container">
        <form class="col-md-12 mt-2" #f=ngForm novalidate>

            <div class="title mb-1 mt-1">
              <div class="title ">

                <div class="row">
                  <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
                 <div class="col-md-7 d-flex justify-content-center">Reseller</div>
                 <div class=" col-md-3 row ">
                   <div class="d-flex justify-content-end">
                    <mat-icon *ngIf="fullScreen" class="mt-2" (click)="toggleFullscreen()">fullscreen_exit</mat-icon>
                    <mat-icon *ngIf="!fullScreen" class="mt-2" (click)="toggleFullscreen()">fullscreen</mat-icon>

                    <!-- <button *ngIf="showCredit" class="btn btn-outline-primary btn-sm " ><img src="assets/images/Add_24.png"></button> -->
                   
                 </div>
                  </div>
                </div>
              
              </div> 
              
              
              </div>

    <div class="d-flex justify-content-start mt-2">
      <div class="col-md-3 mb-2 mt-2  flex justify-content-start">
<span class="form-control">{{userName.name||''}} {{ userName?.email||''}}</span>
        <!-- <p-autoComplete 
    styleClass="col-md-12"
   [(ngModel)]="userName" 
   [dropdown]="true" 
   [suggestions]="filteredUser" 
   (completeMethod)="searchList($event)" 
   field="name">
   <ng-template let-user pTemplate="item">
     <div class="flex align-items-start " style="text-align: start;">
         
         <div>{{ user.name+' , '+ user.username }}</div>
     </div>
 </ng-template>
</p-autoComplete> -->
 </div>
 <div *ngIf="false" class="col-md-8"> <mat-radio-group 
  [(ngModel)]="bookingType"
  class="custom-radio-group" 
>
  <mat-radio-button value="C" color="primary" class="custom-radio-button">Corp</mat-radio-button>
  <mat-radio-button value="P" color="primary" class="custom-radio-button">Personal</mat-radio-button>
  <mat-radio-button value="G" color="primary" class="custom-radio-button">Guest</mat-radio-button>
  </mat-radio-group>  </div>
      <!-- <mat-form-field class="col-md-3" appearance="outline">
        <mat-label>Reseller	</mat-label>
        <input matInput type="text" name="reseller">


      </mat-form-field> -->
    </div>
    
    <!-- <div class="title">Reporting Details</div>

    <div class="section">
      <div class="input-field mt-2 mb-2">
<mat-selection-list>
        <mat-list-option    value="true"   [color]="'primary'" checkboxPosition="before">Personal/Self-pay booking
        </mat-list-option>
      </mat-selection-list>
       
      </div>
    </div> -->
<!-- 
    <div class="title mb-1 mt-1">Item Details</div>

      <div class="d-flex justify-content-start mt-2">
      <mat-form-field class="col-md-3" appearance="outline">

        <mat-label>Default PF Code (Corporate Code)	</mat-label>
        <input matInput type="text" name="corporate Code">


      </mat-form-field>
       
    </div> -->
    <div *ngFor="let itemFlight of flightData ;let indexT=index">
      <div *ngFor="let item of itemFlight.pnrItineraryDetails;let index=index">

      
    <div class="title mb-1 mt-1">AIR: {{dateFormate(item?.schDepartureTime)}} - {{cityFilter(item?.fromAirport)}} to {{cityFilter(item?.toAirport)}}</div>

    <div class="row mt-2" >
        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Source</mat-label>
          <mat-select matNativeControl required name="source+{{index+1}}+{{indexT+1}}" [(ngModel)]="item.source" [ngModelOptions]="{standalone: true}">
            <mat-option *ngFor="let source of sourceCodeList" [value]='source.title'>{{source.name}}</mat-option>
          </mat-select>

        </mat-form-field>
        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Carrier</mat-label>
          <!-- <mat-select matNativeControl required name="carrier+{{index+1}}+{{indexT+1}}" [(ngModel)]="item.carrier" [ngModelOptions]="{standalone: true}">
            <mat-option *ngFor="let carrier of carrierList" [value]="carrier.airlineDesignatorCode">{{carrier.carrierName}}</mat-option>
          </mat-select> -->



          <!-- <mat-form-field class="col-md-12 mt-3 form-group required" appearance="outline"> -->
                            <mat-select-trigger (click)="carrierCodes.open()">
                              <input
                                (input)="carrierCodes.open()"
                                matInput
                                placeholder="Search ..."
                                [(ngModel)]="item.searchCarrierQuery"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="filterCarrier(item)"
                              />
                            </mat-select-trigger>
                      
                            <mat-select
                              #carrierCodes="matSelect"
                              matNativeControl
                             required name="carrier+{{index+1}}+{{indexT+1}}"
                              [(ngModel)]="item.carrier" [ngModelOptions]="{standalone: true}"
                            >
                              <mat-option
                                *ngFor="let item of item.filteredCarrier"
                                [value]="item.airlineDesignatorCode"
                              >
                                {{ item?.carrierName }}, {{ item?.airlineDesignatorCode }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
      
        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Plating carrier</mat-label>
          <!-- <mat-select matNativeControl name="platingCarrier+{{index+1}}+{{indexT+1}}" [(ngModel)]="item.platingCarrier" [ngModelOptions]="{standalone: true}">
            <mat-option *ngFor="let carrier of carrierList" [value]="carrier.airlineDesignatorCode">{{carrier.carrierName}}</mat-option>
          </mat-select> -->
                            <mat-select-trigger (click)="platingCarrier.open()">
                              <input

                                (input)="platingCarrier.open()"
                                matInput
                                placeholder="Search ..."
                                [(ngModel)]="item.searchQuery"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="filterplatingCarrier(item)"
                              />
                            </mat-select-trigger>
                      
                            <mat-select
                              #platingCarrier="matSelect"
                              matNativeControl
                             required name="platingCarrier+{{index+1}}+{{indexT+1}}"
                              [(ngModel)]="item.platingCarrier" [ngModelOptions]="{standalone: true}"
                            >
                              <mat-option
                                *ngFor="let item of item.filteredPlatingCarrier"
                                [value]="item.airlineDesignatorCode"
                              >
                                {{ item?.carrierName }}, {{ item?.airlineDesignatorCode }}
                              </mat-option>
                            </mat-select>

        </mat-form-field>
        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Flight No</mat-label>
          <input matInput type="text" required  [(ngModel)]="item.flightNumber" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Supplier</mat-label>
          <mat-select matNativeControl required name="supplier+{{index+1}}+{{indexT+1}}"  [(ngModel)]="item.supplier" [ngModelOptions]="{standalone: true}">
            <mat-option *ngFor="let supplier of supplierList"  [value]='supplier.code'>{{supplier.name}}</mat-option>
          </mat-select>

        </mat-form-field>
        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>ROE</mat-label>
          <input matInput type="text" name="ROE+{{index+1}}+{{indexT+1}}" [(ngModel)]="item.roe">


        </mat-form-field>
        
        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>PF Code</mat-label>
          <input matInput type="text" name="pfCode+{{index+1}}+{{indexT+1}}" [(ngModel)]="item.privateFareCode">


        </mat-form-field>
        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Currency</mat-label>
          <mat-select matNativeControl name="currency+{{index+1}}+{{indexT+1}}" [(ngModel)]="item.currency">
            <mat-option value="INR">INR - Indian Rup</mat-option>
            <mat-option value="USD">USD - US Dollar</mat-option>        
            </mat-select>

        </mat-form-field>
        <div class="col-md-6" >
          <mat-label>Source</mat-label>

          <input class="form-control"  type="datetime-local" name="source2+{{index+1}}+{{indexT+1}}"  [(ngModel)]="item.schDepartureTime">
          {{cityFilter(item?.fromAirport)}},({{airportFilter(item?.fromAirport)}}-{{item?.fromAirport}})

        </div>
        <div class="col-md-6" >
          <mat-label>Destination</mat-label>
          <input class="form-control" type="datetime-local"  name="Destination2+{{index+1}}+{{indexT+1}}"  [(ngModel)]="item.schArrivalTime">

          {{cityFilter(item?.toAirport)}},({{airportFilter(item?.toAirport)}}-{{item?.toAirport}})

        </div>
    </div>
    <div class="title mb-1 mt-1">Passenger Details</div>

    <div *ngFor="let traveller of item.passengerDetails;let i=index" class="col-md-12  " style="width: 100%;overflow: auto;">
      <table class="table ">
        <thead>
          <tr>
            <th>Passenger	</th>
            <th >Class/Type</th>
            <th >Fare & Tax Breakup</th>
            <th >OPC & GST</th>
            <!-- <th >Extra</th> -->
            <th >Additional</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <!-- <td>1.</td> -->
            <td ><div class="d-flex justify-content-start">
              <strong style="font-size: larger;">{{i+1}}.</strong>
                            <strong *ngIf="manualCartType!='M'" style="font-size: larger;">{{isPassengerCodeValid(traveller?.passengerType)}}</strong>

              
              <mat-form-field  *ngIf="manualCartType==='M'" appearance="outline">

              <mat-select  matNativeControl  name="pType+{{i+1}}+{{index+1}}+{{indexT+1}}" [(ngModel)]="traveller.passengerType">
                <mat-option class="mat-primary" disabled  value="ADT">Adult</mat-option>
                <!-- <mat-option class="mat-primary" value="CHD">Child</mat-option>
                <mat-option class="mat-primary" value="INF">Infant</mat-option> -->
                <mat-option class="mat-primary" disabled *ngIf="item.source!='GALELIO'" value="CHD">Child</mat-option>
                <mat-option class="mat-primary" disabled *ngIf="item.source==='GALELIO'" value="CNN">Child</mat-option>
                <mat-option class="mat-primary" disabled *ngIf="item.source!='AKASA'" value="INF">Infant</mat-option>
                <mat-option class="mat-primary" disabled *ngIf="item.source==='AKASA'" value="INFT">Infant</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

            <div  class="col-md-12">
              {{traveller?.passengerTitle}} {{traveller?.firstName}} {{traveller?.lastName}} </div>

            </td>
            <td>
              <mat-form-field  appearance="outline">
                <mat-label>Booking Class	</mat-label>
                  <input matInput type="text" required name="bClass+{{i+1}}+{{index+1}}+{{indexT+1}}" [(ngModel)]="traveller.bookingClass">
              </mat-form-field>
              <mat-form-field   appearance="outline">
                <mat-label>Cabin Class</mat-label>
                <mat-select matNativeControl name="cabinClass+{{i+1}}+{{index+1}}+{{indexT+1}}" [(ngModel)]="traveller.cabinClass">
                  <mat-option value="">Unset</mat-option>
                  <mat-option value="F">First</mat-option>
                  <mat-option value="Y">Economy</mat-option>
                  <mat-option value="W">Premium Economy</mat-option>
                  <mat-option value="C">Business</mat-option>

                </mat-select>            
                </mat-form-field>
                <mat-form-field  appearance="outline" >
                  <mat-label>Fare Type</mat-label>
                  <input matInput required type="text" name="fareType+{{i+1}}+{{index+1}}+{{indexT+1}}"   [(ngModel)]="traveller.fareType">

                  <!-- <mat-select matNativeControl name="cabinClass" >
			<mat-option value="2">Non Refundable</mat-option>
			<mat-option value="3">Check Fare</mat-option>
			<mat-option value="4">Full Fare</mat-option>
			<mat-option value="1">Non Reschedulable</mat-option>
  
                  </mat-select>             -->
                  </mat-form-field>
            </td>
            <td>

              <mat-form-field  appearance="outline">
                <mat-label>Base</mat-label>
                  <input matInput type="text" name="base+{{i+1}}+{{index+1}}+{{indexT+1}}" required (keypress)="onlyNumberKey($event)"  [(ngModel)]="traveller.baseFare" (input)="total(traveller)">
              </mat-form-field>
              <mat-form-field  appearance="outline">
                <mat-label>YQ</mat-label>
                  <input matInput type="text" name="YQ+{{i+1}}+{{index+1}}+{{indexT+1}}" (keypress)="onlyNumberKey($event)" [(ngModel)]="traveller.YQ" (input)="total(traveller)">
      
              </mat-form-field>
              <mat-form-field  appearance="outline">
                <mat-label>YR</mat-label>
                  <input matInput type="text" name="YR+{{i+1}}+{{index+1}}+{{indexT+1}}" (keypress)="onlyNumberKey($event)" [(ngModel)]="traveller.YR" (input)="total(traveller)">
      
              </mat-form-field>
              <mat-form-field  appearance="outline">
                <mat-label>IN</mat-label>
                  <input matInput type="text" name="IN+{{i+1}}+{{index+1}}+{{indexT+1}}" (keypress)="onlyNumberKey($event)" [(ngModel)]="traveller.IN" (input)="total(traveller)">
      
              </mat-form-field>
              <mat-form-field  appearance="outline" >
                <mat-label>WO</mat-label>
                  <input matInput type="text" name="WO+{{i+1}}+{{index+1}}+{{indexT+1}}" (keypress)="onlyNumberKey($event)" [(ngModel)]="traveller.WO" (input)="total(traveller)">
      
              </mat-form-field>
              <mat-form-field  appearance="outline">
                <mat-label>JN</mat-label>
                  <input matInput type="text" name="JN+{{i+1}}+{{index+1}}+{{indexT+1}}" (keypress)="onlyNumberKey($event)" [(ngModel)]="traveller.JN" (input)="total(traveller)">
      
              </mat-form-field>
            
            </td>
            <td>
           
              <mat-form-field  appearance="outline">
                <mat-label>OB</mat-label>
                  <input matInput type="text" name="OB+{{i+1}}+{{index+1}}+{{indexT+1}}" (keypress)="onlyNumberKey($event)" [(ngModel)]="traveller.OB" (input)="total(traveller)">
      
              </mat-form-field>
              <mat-form-field  appearance="outline">
                <mat-label>OC</mat-label>
                  <input matInput type="text" name="OC+{{i+1}}+{{index+1}}+{{indexT+1}}" (keypress)="onlyNumberKey($event)" [(ngModel)]="traveller.OC" (input)="total(traveller)">
      
              </mat-form-field>
              <mat-form-field  appearance="outline">
                <mat-label>SBC</mat-label>
                  <input matInput type="text" name="SBC+{{i+1}}+{{index+1}}+{{indexT+1}}" (keypress)="onlyNumberKey($event)" [(ngModel)]="traveller.SBC" (input)="total(traveller)">
      
              </mat-form-field>
              <mat-form-field  appearance="outline">
                <mat-label>KKC</mat-label>
                  <input matInput type="text" name="KKC+{{i+1}}+{{index+1}}+{{indexT+1}}" (keypress)="onlyNumberKey($event)" [(ngModel)]="traveller.KKC" (input)="total(traveller)">
      
              </mat-form-field>
              <mat-form-field  appearance="outline">
                <mat-label>CGST</mat-label>
                  <input matInput type="text" name="CGST+{{i+1}}+{{index+1}}+{{indexT+1}}" (keypress)="onlyNumberKey($event)" [(ngModel)]="traveller.CGST" (input)="total(traveller)">
      
              </mat-form-field>
              <mat-form-field  appearance="outline">
                <mat-label>SGST</mat-label>
                  <input matInput type="text" name="SGST+{{i+1}}+{{index+1}}+{{indexT+1}}" (keypress)="onlyNumberKey($event)" [(ngModel)]="traveller.SGST" (input)="total(traveller)">
      
              </mat-form-field>
              <mat-form-field  appearance="outline">
                <mat-label>UGST</mat-label>
                  <input matInput type="text" name="UGST+{{i+1}}+{{index+1}}+{{indexT+1}}" (keypress)="onlyNumberKey($event)" [(ngModel)]="traveller.UGST" (input)="total(traveller)">
      
              </mat-form-field>
              <mat-form-field  appearance="outline">
                <mat-label>IGST</mat-label>
                  <input matInput type="text" name="IGST+{{i+1}}+{{index+1}}+{{indexT+1}}" (keypress)="onlyNumberKey($event)" [(ngModel)]="traveller.IGST" (input)="total(traveller)">
      
              </mat-form-field>

            </td>
            <!--<td>
              <mat-form-field  appearance="outline">
                <mat-label>Seat</mat-label>
                  <input matInput type="text" name="Seat" (keypress)="onlyNumberKey($event)" [(ngModel)]="traveller.seatBasePrice" (input)="total(traveller)">
      
              </mat-form-field>
              <mat-form-field  appearance="outline">
                <mat-label>Meal</mat-label>
                  <input matInput type="text" name="Meal" (keypress)="onlyNumberKey($event)" [(ngModel)]="traveller.mealBasePrice" (input)="total(traveller)">
      
              </mat-form-field>
              <mat-form-field  appearance="outline">
                <mat-label>Baggage</mat-label>
                  <input matInput type="text" name="Baggage" (keypress)="onlyNumberKey($event)" [(ngModel)]="traveller.baggage">
      
              </mat-form-field> 
              
              
            </td>-->
            <td style="min-width:200px;">
              <span class="col-md-12 row" *ngFor="let coc of traveller.coc;let c=index">
                  <mat-form-field class="col-md-6"  appearance="outline">
                  <input matInput type="text" name="coc+{{i+1}}+{{c+1}}+{{index+1}}+{{indexT+1}}" placeholder="Coc" [(ngModel)]="coc.key" (input)="total(traveller)">
                 </mat-form-field>
                 <mat-form-field  class="col-md-6" appearance="outline">
                  <input matInput type="text" name="cocValue+{{i+1}}+{{c+1}}+{{index+1}}+{{indexT+1}}" (keypress)="onlyNumberKey($event)" [(ngModel)]="coc.value" (input)="total(traveller)">
                 </mat-form-field>
                </span>
              
            </td>
          

          </tr>
        <tr>
        <td></td>
        <td><strong>Total Price :</strong> {{traveller.totalPrice}}</td>
        <td>{{traveller.baseTotal}}</td>
        <td>{{traveller.taxTotal}}</td>
        <!-- <td>{{traveller.extraTotal}}</td> -->
        <td>{{traveller.cocTotal}}</td>


        </tr >
        <tr>
          <!-- \<td></td> -->
          
          <th> PNR	</th>
          <th>CRS PNR	</th>
          <th>UniversalPnr</th>

          <th>Airline Pnr</th>
          <th>Ticket Number	</th>
          <!-- <th></th> -->
          </tr >
          <tr>
            <td>
               <mat-form-field  appearance="outline">
              <input matInput type="text" required name="pnr+{{i+1}}+{{index+1}}+{{indexT+1}}" [(ngModel)]="traveller.pnr" >
          </mat-form-field>
        </td>
        <td><mat-form-field  appearance="outline">
          <input matInput type="text" name="csrPnr+{{i+1}}+{{index+1}}+{{indexT+1}}"  [(ngModel)]="traveller.csrPnr">
      </mat-form-field></td>
        <td> <mat-form-field  appearance="outline">
          <input matInput type="text" name="universalPnr+{{i+1}}+{{index+1}}+{{indexT+1}}" [(ngModel)]="traveller.universalPnr" >
      </mat-form-field></td>
        <td> <mat-form-field  appearance="outline">
          <input matInput type="text" name="providerPnr+{{i+1}}+{{index+1}}+{{indexT+1}}" [(ngModel)]="traveller.providerPnr" >
      </mat-form-field></td>

            
            <td><mat-form-field  appearance="outline">
              <input matInput type="text" name="ticket+{{i+1}}+{{index+1}}+{{indexT+1}}" [(ngModel)]="traveller.ticketNumber" >
          </mat-form-field></td>
            <!-- <td></td> -->
    
    
            </tr >
            <tr *ngIf="false">
              <!-- <td></td> -->
              <th></th>

              <th></th>
              <th>Meal preference	</th>
              <th>
                <!-- Seat Preference: -->
                	</th>
              <th>
                Seat Number
              		</th>
              <th>
                <!-- Baggage Preference	 -->
              </th>
              </tr >
              <tr *ngIf="false">
                <td></td>
                <td></td>
                <td>
                   <mat-form-field  appearance="outline">
                  <input matInput type="text" name="meal+{{i+1}}+{{index+1}}" [(ngModel)]="traveller.mealPreference" >
              </mat-form-field>
            </td>
                <td>
                  <!-- <mat-form-field  appearance="outline">
                  <input matInput type="text" name="seat" [(ngModel)]="traveller.seatPreference" >
              </mat-form-field> -->


            </td>
                <td>
                  <mat-form-field  appearance="outline">
                  <input matInput type="text" name="number+{{i+1}}+{{index+1}}" [(ngModel)]="traveller.seatNumber" >
              </mat-form-field>
            </td>
                <td>
                  <!-- <mat-form-field  appearance="outline">
                  <input matInput type="text" name="baggage" [(ngModel)]="traveller.baggagePreference" >
              </mat-form-field> -->
            </td>
        
        
                </tr >

        </tbody>
      </table>
    </div>

   </div>
</div>

    <div class="section">
      <button class="btn btn-outline-success c-width-100px shadow" [disabled]="disabled(f)" (click)="saveCart()" >Create Cart</button>
      <button class="btn btn-outline-success c-width-100px shadow"  style="margin-left: 4px;" [disabled]="disabled(f)"  (click)="createCart()"  >Save Cart</button>
    </div>
</form>
  </div>
